import React, { ReactNode, useContext } from 'react';
import { LaunchDarklyProvider } from '@/providers/launchdarkly-provider';
import { useOrgStore } from '@/stores/org-store';
import { AuthContext } from '@/context/auth-context';
import { LoadingSpinner } from '@/components/loading-spinner';

interface LaunchDarklyWrapperProps {
  children: ReactNode;
}

export const LaunchDarklyWrapper: React.FC<LaunchDarklyWrapperProps> = ({
  children,
}) => {
  const { currentOrg } = useOrgStore();
  const { loading, user } = useContext(AuthContext);

  // Wait for auth to complete
  // For authenticated users, also wait for currentOrg to be available
  // For non-authenticated users, proceed with undefined orgId (anonymous context)
  if (loading || (user && !currentOrg)) {
    return <LoadingSpinner fullScreen size='lg' />;
  }

  return (
    <LaunchDarklyProvider orgId={currentOrg?.orgid}>
      {children}
    </LaunchDarklyProvider>
  );
};
